var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLayerIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 60,
    viewBox: "0 0 78 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_43)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M36.4638 31.0966C38.0229 30.5175 39.7381 30.5175 41.2972 31.0966L74.3206 43.3635C75.5193 43.8088 75.5293 45.5006 74.3359 45.96L41.58 58.57C39.9836 59.1845 38.2165 59.1879 36.6177 58.5794L3.44976 45.9546C2.25227 45.4988 2.25909 43.8023 3.46021 43.3562L36.4638 31.0966Z",
    fill: "url(#paint0_radial_2_43)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M41.1753 25.6637L74.1987 37.9306C75.0951 38.2636 75.1026 39.5289 74.2102 39.8724L41.4542 52.4824C39.9384 53.0659 38.2603 53.0691 36.7423 52.4913L3.57427 39.8665C2.67873 39.5256 2.68383 38.2569 3.58208 37.9233L36.5857 25.6637C38.0662 25.1138 39.6949 25.1138 41.1753 25.6637Z",
    fill: "url(#paint1_radial_2_43)",
    stroke: "#FAA6A6",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9996 24.761L25.9996 38.761",
    stroke: "url(#paint2_linear_2_43)",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.9996 33.761L46.9996 46.761",
    stroke: "url(#paint3_linear_2_43)",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9996 17.761L15.9997 43.761",
    stroke: "url(#paint4_linear_2_43)",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M30.9996 40.761L30.9996 47.7012",
    stroke: "url(#paint5_linear_2_43)",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M34.9996 30.761L34.9996 36.5445",
    stroke: "url(#paint6_linear_2_43)",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.9996 11.761L50.9996 33.761",
    stroke: "url(#paint7_linear_2_43)",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.9996 23.761L65.9996 39.761",
    stroke: "url(#paint8_linear_2_43)",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.9996 2.76099L38.9996 21.761",
    stroke: "url(#paint9_linear_2_43)",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_2_43",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(38.8805 44.6415) rotate(-179.341) scale(33.9952)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D75252",
    stopOpacity: 0.65
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D24C4C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_2_43",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(38.8805 38.8805) rotate(-179.341) scale(33.9952)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.119792,
    stopColor: "#D75252",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D24C4C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2_43",
    x1: 26.4996,
    y1: 24.761,
    x2: 26.4996,
    y2: 38.761,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.186384,
    stopColor: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9F9F9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2_43",
    x1: 47.4996,
    y1: 33.761,
    x2: 47.4996,
    y2: 46.761,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D74E55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D74E55",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2_43",
    x1: 16.4996,
    y1: 17.761,
    x2: 16.4997,
    y2: 43.761,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.578328,
    stopColor: "#D74E55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D74E55",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2_43",
    x1: 31.4996,
    y1: 40.761,
    x2: 31.4996,
    y2: 47.7012,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D74E55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D74E55",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2_43",
    x1: 35.4996,
    y1: 30.761,
    x2: 35.4996,
    y2: 36.5445,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D74E55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D74E55",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2_43",
    x1: 51.4996,
    y1: 11.761,
    x2: 51.4996,
    y2: 33.761,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.166667,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2_43",
    x1: 66.4996,
    y1: 23.761,
    x2: 66.4996,
    y2: 39.761,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.610377,
    stopColor: "#D74E55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D74E55",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2_43",
    x1: 39.4996,
    y1: 2.76099,
    x2: 39.4996,
    y2: 21.761,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D74E55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D74E55",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_43"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 78,
    height: 60,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLayerIcon);
export default __webpack_public_path__ + "static/media/layer-icon.412eb256d78bd8702ee5cf1a1c5b5fff.svg";
export { ForwardRef as ReactComponent };